import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Paper from "@material-ui/core/Paper/Paper";
import Toolbar from "../../components/Toolbar/Toolbar";
import CardContent from "@material-ui/core/CardContent/CardContent";
import AppointmentForm from "../../components/Appointments/AppointmentForm";

const AppointmentsCreate = ({classes, customer, machines, technicians, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('appointments.new_appointment')}
        />

        <Paper>
            <CardContent>
                <AppointmentForm
                    customer={customer}
                    machines={machines}
                    technicians={technicians}
                    formUrl={formUrl}
                    isEdit={false}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Paper>
    </Layout>
);

export default AppointmentsCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/appointments/Create.jsx